// extracted by mini-css-extract-plugin
export default {"title":"Settings_title__knuhG","content":"Settings_content__NaSaR","tabs":"Settings_tabs__3vtyA","tabList":"Settings_tabList__UuBU9","addNewCard":"Settings_addNewCard__JwcnA"};